import React, { Fragment, useState } from 'react'

import { IAttachedFileWithUrl } from '../../../../interfaces/services';

import FileManagement from './FileManagement';

interface IAttachFilesProps {
    attachedFiles: IAttachedFileWithUrl[];
    setAttachedFiles: React.Dispatch<React.SetStateAction<IAttachedFileWithUrl[]>>;
    filesToUpload: File[];
    setFilesToUpload: React.Dispatch<React.SetStateAction<File[]>>;
    isDisabled: boolean;
}

const AttachFiles = (props: IAttachFilesProps) => {
    const { attachedFiles, setAttachedFiles, filesToUpload, setFilesToUpload, isDisabled } = props;

    const [openFileManagement, setOpenFileManagement] = useState<boolean>(false);

    const handleOpenFileManagement = () => {
        if (isDisabled) return;

        setOpenFileManagement(true);
    };

    const handleCloseFileManagement = () => {
        if (isDisabled) return;

        setOpenFileManagement(false);
    };

    const handleUploadFile = (file: File) => {
        if (isDisabled) return;

        setFilesToUpload([...filesToUpload, file]);
    };

    const handleRemoveFile = (file: File) => {
        if (isDisabled) return;

        setFilesToUpload(filesToUpload.filter(f => f !== file));
    };

    const handleRemoveAttachedFile = (file: IAttachedFileWithUrl) => {
        if (isDisabled) return;

        setAttachedFiles(attachedFiles.filter(f => f.id !== file.id));
    };

    const handlePreviewLocalFile = (file: File) => {
        if (isDisabled) return;

        const fileType = file.name.toLowerCase().split('.').pop();

        if (['doc', 'docx'].includes(fileType || '')) {
            // For Word documents, might want to show a message
            alert('Word documents cannot be previewed directly in the browser. Please download the file to view it.');
            return;
        }

        const fileUrl = URL.createObjectURL(file);
        window.open(fileUrl, '_blank');

        setTimeout(() => {
            URL.revokeObjectURL(fileUrl);
        }, 100);
    };

    const handlePreviewAttachedFile = (file: IAttachedFileWithUrl) => {
        if (isDisabled) return;

        window.open(file.url, '_blank');
    };

    const handleDownloadLocalFile = (file: File) => {
        if (isDisabled) return;

        const fileUrl = URL.createObjectURL(file);
        const a = document.createElement('a');
        a.href = fileUrl;
        a.download = file.name;
        a.click();

        setTimeout(() => {
            URL.revokeObjectURL(fileUrl);
        }, 100);
    };

    const handleDownloadAttachedFile = (file: IAttachedFileWithUrl) => {
        if (isDisabled) return;

        const a = document.createElement('a');
        a.href = file.url;
        a.download = file.asset_name;
        a.click();
    };

    return (
        <Fragment>
            <div className={`immployer__attach_files ${isDisabled ? 'immployer__attach_files__disabled' : ''}`}>
                <label className='immployer__attach_files__label'>
                    Attach File(s)
                    {(attachedFiles.length > 0 || filesToUpload.length > 0) && (
                        <span className='immployer__attach_files__count'>
                            ({attachedFiles.length + filesToUpload.length})
                        </span>
                    )}
                </label>
                <button
                    className={`immployer__btn immployer__btn__secondary immployer__attach_files__btn ${isDisabled ? 'immployer__btn__secondary__disabled' : ''}`}
                    onClick={handleOpenFileManagement}
                    disabled={isDisabled}
                >
                    Select Files
                </button>
            </div>
            {openFileManagement && !isDisabled && (
                <FileManagement
                    attachedFiles={attachedFiles}
                    filesToUpload={filesToUpload}
                    handleUploadFile={handleUploadFile}
                    handleRemoveFile={handleRemoveFile}
                    handleRemoveAttachedFile={handleRemoveAttachedFile}
                    handlePreviewLocalFile={handlePreviewLocalFile}
                    handlePreviewAttachedFile={handlePreviewAttachedFile}
                    handleDownloadLocalFile={handleDownloadLocalFile}
                    handleDownloadAttachedFile={handleDownloadAttachedFile}
                    handleCloseFileManagement={handleCloseFileManagement}
                />
            )}
        </Fragment>
    )
}

export default AttachFiles;